export default __webpack_public_path__ + "static/media/Scenery04.f4a0ae1d.jpg";